import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, FormHelperText, Radio, RadioGroup } from '@mui/material'
import { Controller } from 'react-hook-form'
import { OptionItem } from './elements'

const Option = ({ name, control, errors, options }) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field }) => (
        <FormControl fullWidth>
          <RadioGroup
            {...field}
            id={name}
            onChange={(e) => {
              field.onChange(e.target.value)
            }}
            sx={{
              px: '1rem',
            }}
          >
            {options.map((opt, idx) => {
              const selected = field.value === opt.value

              // cek apakah value adalah URL (anggap semua URL gambar)
              const isImage = typeof opt.value === 'string' && /^https?:\/\//i.test(opt.value)

              return (
                <OptionItem
                  key={idx}
                  value={opt.value}
                  control={<Radio />}
                  label={
                    isImage ? (
                      <img
                        src={opt.value}
                        alt={`option-${idx}`}
                        style={{
                          maxWidth: '200px',
                          maxHeight: '150px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      opt.label || opt.name || opt.value
                    )
                  }
                  slotProps={{
                    typography: {
                      sx: {
                        fontWeight: selected ? 700 : 'unset',
                      },
                    },
                  }}
                  sx={{
                    backgroundColor: ({ palette }) =>
                      selected ? palette['background.4'].light : 'inherit',
                  }}
                />
              )
            })}
          </RadioGroup>
          <FormHelperText error={!!errors[name]}>
            {errors[name] && errors[name].message}
          </FormHelperText>
        </FormControl>
      )}
    />
  )
}

Option.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  control: PropTypes.any.isRequired,
  errors: PropTypes.object,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      name: PropTypes.string,
    }),
  ),
}

export default Option
